import type {
  ArticleCard as ArticleCardType,
  FeatureListItem
} from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';
import Tracked from '~/components/Tracked';

const MODULE_TYPE = 'recent-features';

function toArticleCard({ id, image, link }: FeatureListItem): ArticleCardType {
  return {
    author: { name: '', path: '' },
    id,
    images: [{ alt: image.alt, ratio: '4:5', url: image.url }],
    link,
    published_at: 0,
    section: 'Feature',
    title: link.text
  };
}

function ViewMoreButton() {
  return (
    <div className="w-36">
      <Tracked.ExternalLink
        variant="transparent-white-border"
        className="flex items-center justify-center"
        pagePosition="Body"
        name="DISCOVER_MORE_FEATURES"
        href="/news/features/"
      >
        View more
      </Tracked.ExternalLink>
    </div>
  );
}

function Carousel({ items }: { items: FeatureListItem[] }) {
  return (
    <div className="carousel-width no-scrollbar flex items-start gap-2 pb-4 md:gap-6">
      {items.map((item, index) => (
        <ArticleCard
          className="min-w-[285px] max-w-[50vw] flex-1 md:min-w-[345px]"
          key={item.link.path}
          item={toArticleCard(item)}
          moduleType={MODULE_TYPE}
          name="LATEST_FEATURES"
          pagePosition="Lifestyle News Discover More"
          position={index + 1}
          variant="4/5-text-over"
        />
      ))}
    </div>
  );
}

export default function RecentFeatures({
  title,
  items
}: {
  items: FeatureListItem[];
  title: string;
}) {
  return (
    items.length > 0 && (
      <div className="w-full bg-black py-10 text-white md:py-20">
        <div className="content-width flex flex-col items-center justify-center gap-8 md:gap-10">
          <h1 className="text-title-xl w-full text-center">{title}</h1>
          <Carousel items={items} />
          <ViewMoreButton />
        </div>
      </div>
    )
  );
}
